/**
 * @param {Array} columns
 * @param {boolean} selectable
 * @param {boolean} hasRowActions
 * @returns {string} CSS grid-template-columns value
 */
export const getGridColumns = (columns, selectable, hasRowActions, actionsColumnWidth = "80px") => {
  const parts = [
    ...(selectable ? ["24px"] : []),
    ...columns.map((c) => {
      if (c.flexGrow != null) {
        const base = c.width ?? "min-content";
        return `minmax(${base}, ${c.flexGrow}fr)`;
      }
      return c.width ?? "1fr";
    }),
    ...(hasRowActions ? [actionsColumnWidth] : []),
  ];
  return parts.join(" ");
};
